export type GetLoansRequest = {
  orderId: number;
  page: number;
  pageSize: number;
  sorts?: string;
  filters?: string;
};

export enum LoanDocumentStatus {
  Unknown = 'Unknown',
  New = 'New',
  DownloadedToLocalStorage = 'Downloaded To Local Storage',
  FailedToDownloadToLocalStorage = 'Failed To Download To Local Storage',
  DecryptionCompleted = 'Decryption Completed',
  FailedToDecrypt = 'Failed To Decrypt',
  Unzipping = 'Unzipping',
  UnzippedToDefaultStorage = 'Unzipped To Default Storage',
  CopiedToDefaultStorage = 'Copied To Default Storage',
  FailedToCopyToDefaultStorage = 'Failed To Copy To Default Storage',
  FailedToUnzipToDefaultStorage = 'Failed To Unzip To Default Storage',
  CheckingForDuplicates = 'Checking For Duplicates',
  CompletedDuplicatesCheck = 'Completed Duplicates Check',
  FailedToCheckForDuplicates = 'Failed To Check For Duplicates',
  SkippedProcessing = 'Skipped Processing',
  Indexing = 'Indexing',
  FailedToTriggerIndexing = 'Failed To Trigger Indexing',
  FailedToIndex = 'Failed To Index',
  IndexingCompleted = 'Indexing Completed',
  SplittingIndexedPdfs = 'Splitting Indexed PDFs',
  FailedToSplitIndexedPdfs = 'Failed To Split Indexed PDFs',
  SplitIndexedPdfsCompleted = 'Split Indexed PDFs Completed',
  SecondIndexing = 'Second Indexing',
  FailedToTriggerSecondIndexing = 'Failed To Trigger Second Indexing',
  FailedToSecondIndex = 'Failed To Second Index',
  SecondIndexingCompleted = 'Second Indexing Completed',
  IndexingMetadataExtracting = 'Indexing Metadata Extracting',
  FailedToTriggerIndexingMetadataExtraction = 'Failed To Trigger Indexing Metadata Extraction',
  FailedToExtractIndexingMetadata = 'Failed To Extract Indexing Metadata',
  IndexingMetadataExtractionCompleted = 'Indexing Metadata Extraction Completed',
  Extracting = 'Extracting',
  FailedToTriggerExtraction = 'Failed To Trigger Extraction',
  FailedToExtract = 'Failed To Extract',
  ExtractionCompleted = 'Extraction Completed',
  SkippedExtraction = 'Skipped Extraction',
  FetchingExtractionResults = 'Fetching Extraction Results',
  FailedToFetchExtractionResults = 'Failed To Fetch Extraction Results',
  ExtractionResultsFetched = 'Extraction Results Fetched',
  Completed = 'Completed'
}

export type LoanStatusCount = {
  status: string;
  count: number;
};

export enum LoanProcessingStatus {
  Unknown = 'Unknown',
  New = 'New',
  Processing = 'Processing',
  Processed = 'Processed',
  ProcessedWithError = 'Processed With Error',
  Error = 'Error',
  AwaitingIndexingMetadata = 'Awaiting Indexing Metadata',
  FinalizingIndexingMetadata = 'Finalizing Indexing Metadata',
  ResolvingBestValue = 'Resolving Best Value'
}

export enum OrderStatus {
  Created = 'Created',
  Initializing = 'Scanning for Loans',
  InitializationFailed = 'Loan Scan Failed',
  Processing = 'Processing',
  Completed = 'Completed',
  CompletedWithError = 'Completed With Error',
  Error = 'Error'
}
